// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { EventEmitter } from 'events';
export class AbstractViewModel {
    constructor(ComponentView) {
        this._eventEmitter = new EventEmitter();
        this.componentView = new ComponentView();
    }
    dispose() {
        /* virtual */
    }
    initialize(props) {
        /* virtual */
    }
    update(props, prevProps) {
        /* virtual */
    }
    updateComponentView(key, value, forceUpdate = false, isNotify = true) {
        let isUpdatedValue = false;
        if (forceUpdate) {
            isUpdatedValue = true;
        }
        else {
            isUpdatedValue = this.componentView[key] !== value;
        }
        this.componentView[key] = value;
        if (isUpdatedValue && isNotify) {
            this._eventEmitter.emit('update', key, value);
            return true;
        }
        return false;
    }
    addToArray(key, value, toBegin = false, isNotify = true) {
        const array = this.componentView[key];
        if (toBegin) {
            array.unshift(value);
        }
        else {
            array.push(value);
        }
        if (isNotify) {
            this._eventEmitter.emit('addItem', key, value, toBegin ? 0 : array.length - 1);
        }
    }
    insertToArray(key, value, index, isNotify = true) {
        const array = this.componentView[key];
        array.splice(index, 0, value);
        if (isNotify) {
            this._eventEmitter.emit('addItem', key, value, index);
        }
    }
    removeFromArray(key, value, isNotify = true) {
        const array = this.componentView[key];
        const index = array.indexOf(value);
        if (index >= 0) {
            array.splice(index, 1);
        }
        if (isNotify) {
            this._eventEmitter.emit('removeItem', key, value, index);
        }
    }
    updateInArray(key, value, isNotify = true) {
        const array = this.componentView[key];
        const index = array.indexOf(value);
        if (isNotify) {
            this._eventEmitter.emit('updateItem', key, value, index);
        }
    }
    subscribeToAddItem(callback) {
        this._eventEmitter.on('addItem', callback);
    }
    unsubscribeFromAddItem(callback) {
        this._eventEmitter.off('addItem', callback);
    }
    subscribeToRemoveItem(callback) {
        this._eventEmitter.on('removeItem', callback);
    }
    unsubscribeFromRemoveItem(callback) {
        this._eventEmitter.off('removeItem', callback);
    }
    subscribeToUpdateItem(callback) {
        this._eventEmitter.on('updateItem', callback);
    }
    unsubscribeFromUpdateItem(callback) {
        this._eventEmitter.off('updateItem', callback);
    }
    subscribeToUpdate(callback) {
        this._eventEmitter.on('update', callback);
    }
    unsubscribeFromUpdate(callback) {
        this._eventEmitter.off('update', callback);
    }
}
